<template lang="pug">
router-link.card.no-decoration(:to="{ name: 'app.ouvidoria.show', params: { id: ocorrencia.id } }")
  .card-body
    .float-right
      i.fa.fa-chevron-right.text-primary
    .columns
      .column.col-auto
        img.img-responsive.s-rounded(:src="ocorrencia.processo.categoria.icone" style="width: 40px")
      .column
        .h6 {{ ocorrencia.processo.categoria.descricao }}
  .card-footer
    .columns.align-center
      .column
        .text-small.text-gray {{ ocorrencia.created_at | date }}
      .column.col-auto
        | {{ `enums.db.enum_processo_situacao.${ocorrencia.processo.situacao}` | translate }}
</template>

<script>
export default {
  props: { ocorrencia: { type: Object, required: true } },
};
</script>
